import React from "react";
import PropTypes from 'prop-types'
import {Typography} from "@material-ui/core";

const SurveyHeader = ({title, styles}) => {
    return (
        <div style={{
            background: styles.background,
            textAlign: styles.textAlign,
            padding: styles.padding
        }}>
            <Typography style={{
                padding: 5,
                fontWeight: styles.fontWeight,
                fontStyle: styles.fontStyle,
                fontSize: styles.fontSize,
                color: styles.color,
            }}>
                {title}
            </Typography>
        </div>
    )
};
export default SurveyHeader

SurveyHeader.propTypes = {
    title: PropTypes.string,
    surveyHeader: PropTypes.object,
    path: PropTypes.string
};